import userHighlightStore from '../store/userHighlightStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('addHighlightId', (highlightId: string, originalHighlight: string) => {
    const highlightIds = userHighlightStore.highlightIds;
    if (!highlightIds.has(highlightId)) {
        highlightIds.set(highlightId, originalHighlight);
    }
});
